import { createContext } from 'react';

import { LoginCredentials, AuthResponse } from '@lib/auth';

import { User } from './UserContext';

export interface UserContextType {
    user: User | null;
    loading: boolean;
    error: string | null;
    refreshUser: () => Promise<void>;
    isAuthenticated: boolean;
    login: (credentials: LoginCredentials) => Promise<AuthResponse>;
    logout: () => Promise<AuthResponse>;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);